import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Tag, App, Popconfirm, Empty, Spin } from 'antd';
import { DeleteOutlined, MessageOutlined } from '@ant-design/icons';
import AppLayout from '../components/AppLayout';
import api from '../api/client';
import dayjs from 'dayjs';

export default function AdminFeedback() {
  const { message } = App.useApp();
  const [rows, setRows]     = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get('/api/admin/feedback')
      .then(r => setRows(r.data))
      .catch(() => message.error('Failed to load feedback'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    try { await api.delete(`/api/admin/feedback/${id}`); message.success('Deleted'); load(); }
    catch { message.error('Delete failed'); }
  };

  const columns = [
    {
      title: 'User',
      dataIndex: 'name',
      width: 160,
      render: (name, row) => (
        <div>
          <div style={{ fontWeight: 600, fontSize: 13 }}>{name}</div>
          <div style={{ fontSize: 11, color: '#888' }}>@{row.username}</div>
          <Tag style={{ fontSize: 10, marginTop: 2 }}>{row.role_name}</Tag>
        </div>
      ),
    },
    {
      title: 'Message',
      dataIndex: 'message',
      render: msg => <div style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>{msg}</div>,
    },
    {
      title: 'Date',
      dataIndex: 'created_at',
      width: 140,
      render: d => <span style={{ fontSize: 12, color: '#888' }}>{dayjs(d).format('D MMM YYYY h:mm A')}</span>,
    },
    {
      title: '',
      width: 48,
      render: (_, row) => (
        <Popconfirm title="Delete this feedback?" onConfirm={() => remove(row.feedback_id)}>
          <Button type="text" danger size="small" icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <AppLayout>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>
          <MessageOutlined style={{ marginRight: 10 }} />User Feedback
        </h1>
        <p style={{ color: '#888', marginTop: 4, marginBottom: 0 }}>Feedback submitted by users via the in-app button.</p>
      </div>

      {loading
        ? <div style={{ textAlign: 'center', padding: 80 }}><Spin /></div>
        : rows.length === 0
          ? <Empty description="No feedback yet." style={{ padding: 80 }} />
          : (
            <Card variant="outlined" style={{ borderColor: '#e8e8e8' }}>
              <Table
                dataSource={rows}
                columns={columns}
                rowKey="feedback_id"
                pagination={{ pageSize: 20 }}
                size="middle"
              />
            </Card>
          )
      }
    </AppLayout>
  );
}
